import { useCallback } from "react";

import { useTranslation } from "react-i18next";

import type { MissingOfferLabelResolver } from "./offerAnalytics.types";

const SHORT_UUID_LENGTH = 8;

function useMissingOfferLabel(): MissingOfferLabelResolver {
  const { t } = useTranslation("editor-analytics");

  return useCallback(
    (offerUuid) =>
      offerUuid
        ? t("offerAnalytics.deletedOffer", {
            id: offerUuid.slice(0, SHORT_UUID_LENGTH),
          })
        : t("offerAnalytics.unknownOffer"),
    [t],
  );
}

export default useMissingOfferLabel;
